import * as XLSX from 'xlsx';

export interface ExcelTableData {
    Header: { Columns: string[] };
    Rows: { Columns: string[] }[];
    Footer?: { Columns: string[] };
    SubTitle?: string;
    Title: string;
}

/**
 * Generates an Excel file from table data and downloads it
 * @param tables - Array of table data to include in the Excel file
 * @param filename - Name of the file to download (should include .xlsx extension)
 */
export const generateExcel = (tables: ExcelTableData[], filename: string = 'report.xlsx') => {
    // Create a new workbook
    const workbook = XLSX.utils.book_new();

    tables.forEach((table, tableIndex) => {
        // Prepare the data for the worksheet
        const worksheetData: string[][] = [];

        // Add title if present
        if (table.Title) {
            worksheetData.push([table.Title]);
            worksheetData.push([]); // Empty row for spacing
        }

        // Add subtitle if present
        if (table.SubTitle) {
            worksheetData.push([table.SubTitle]);
            worksheetData.push([]); // Empty row for spacing
        }

        // Add headers
        if (table.Header?.Columns?.length > 0) {
            worksheetData.push(table.Header.Columns);
        }

        // Add data rows
        if (table.Rows?.length > 0) {
            table.Rows.forEach(row => {
                if (row.Columns?.length > 0) {
                    worksheetData.push(row.Columns);
                }
            });
        }

        // Add footer if present
        if (table.Footer?.Columns && table.Footer.Columns.length > 0) {
            worksheetData.push([]); // Empty row for spacing
            worksheetData.push(table.Footer.Columns);
        }

        // Create worksheet from the data
        const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);

        // Set column widths for better display (optional)
        const columnWidths = table.Header?.Columns?.map(() => ({ wch: 20 })) || [];
        worksheet['!cols'] = columnWidths;

        // Add the worksheet to the workbook
        const sheetName = tables.length > 1 ? `${table.Title || 'Sheet'} ${tableIndex + 1}` : (table.Title || 'Sheet1');
        XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
    });

    // Generate the Excel file and trigger download
    XLSX.writeFile(workbook, filename);
};
